import HttpService from "./HttpService";

const BASE = () => window.API_URL + "/communication/scheduler";

const SchedulerService = {
  // ── Templates ──────────────────────────────────────────────────────────
  getTemplates: (employerId) =>
    HttpService.getAxiosClient().get(
      BASE() + "/templates" + (employerId ? `?employerId=${employerId}` : "")
    ),

  createTemplate: (body) =>
    HttpService.getAxiosClient().post(BASE() + "/templates", body),

  updateTemplate: (id, body) =>
    HttpService.getAxiosClient().put(BASE() + `/templates/${id}`, body),

  cloneTemplate: (id, targetEmployerId) =>
    HttpService.getAxiosClient().post(
      BASE() +
        `/templates/${id}/clone` +
        (targetEmployerId ? `?targetEmployerId=${targetEmployerId}` : ""),
      {}
    ),

  // ── Tasks ──────────────────────────────────────────────────────────────
  getTask: (taskId) =>
    HttpService.getAxiosClient().get(BASE() + `/tasks/${taskId}`),

  getDays: (templateId) =>
    HttpService.getAxiosClient().get(BASE() + `/templates/${templateId}/days`),

  upsertDay: (templateId, body) =>
    HttpService.getAxiosClient().post(
      BASE() + `/templates/${templateId}/days`,
      body
    ),

  deleteDay: (templateId, dayId) =>
    HttpService.getAxiosClient().delete(
      BASE() + `/templates/${templateId}/days/${dayId}`
    ),

  // ── Tasks ──────────────────────────────────────────────────────────────
  getTasks: (dayId) =>
    HttpService.getAxiosClient().get(BASE() + `/days/${dayId}/tasks`),

  upsertTask: (dayId, body) =>
    HttpService.getAxiosClient().post(BASE() + `/days/${dayId}/tasks`, body),

  // ── Campaigns ──────────────────────────────────────────────────────────
  getCampaigns: (employerId) =>
    HttpService.getAxiosClient().get(
      BASE() + "/campaigns" + (employerId ? `?employerId=${employerId}` : "")
    ),

  getCampaignInstanceStats: (campaignId) =>
    HttpService.getAxiosClient().get(
      BASE() + `/campaigns/${campaignId}/instance-stats`
    ),

  createCampaign: (body) =>
    HttpService.getAxiosClient().post(BASE() + "/campaigns", body),

  getPreauthorizedStatuses: (employerId) =>
    HttpService.getAxiosClient().get(
      BASE() +
        "/campaigns/preauthorized-statuses" +
        (employerId ? `?employerId=${employerId}` : "")
    ),

  getPreauthorizedPreview: ({ employerId, status, dateFrom, dateTo } = {}) => {
    const params = new URLSearchParams();
    if (employerId) params.append("employerId", employerId);
    if (status) params.append("status", status);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    return HttpService.getAxiosClient().get(
      BASE() + "/campaigns/preauthorized-preview?" + params.toString()
    );
  },

  // ── Instances & Executions ─────────────────────────────────────────────
  getInstances: ({
    employerId,
    status,
    idEmployee,
    campaignId,
    page = 0,
    pageSize = 25,
  } = {}) => {
    const params = new URLSearchParams();
    if (employerId) params.append("employerId", employerId);
    if (status && status !== "ALL") params.append("status", status);
    if (idEmployee) params.append("idEmployee", idEmployee);
    if (campaignId) params.append("campaignId", campaignId);
    params.append("page", page);
    params.append("pageSize", pageSize);
    return HttpService.getAxiosClient().get(
      BASE() + "/instances?" + params.toString()
    );
  },

  getEmployeeInstances: (employeeId, scheduleType) =>
    HttpService.getAxiosClient().get(
      BASE() +
        `/employees/${employeeId}/instances` +
        (scheduleType ? `?scheduleType=${scheduleType}` : "")
    ),

  getExecutions: (instanceId) =>
    HttpService.getAxiosClient().get(
      BASE() + `/instances/${instanceId}/executions`
    ),
};

export default SchedulerService;
